import { Injectable } from '@angular/core';
import { Loader} from "@googlemaps/js-api-loader";

@Injectable({
  providedIn: 'root'
})
export class GenericsService {

  info = {
    rrss: {
      instagram: 'https://www.instagram.com/wecode.ve/',
      email: 'info@Wecode.network',
    }
  };

  menu = [
    {
      id: 1,
      title: 'Espacios',
      isExternal: false,
      link: '/',
      isFragment: true,
      fragment: 'espacios',
      active: true
    },
    {
      id: 2,
      title: 'Que ofrecemos',
      isExternal: false,
      link: '/',
      isFragment: true,
      fragment: 'whatOffert',
      active: true
    },
    {
      id: 3,
      title: 'Nuestros Planes',
      isExternal: false,
      link: '/',
      isFragment: true,
      fragment: 'oursPlans',
      active: true
    },
    {
      id: 4,
      title: 'Membresia',
      isExternal: false,
      link: '/',
      isFragment: true,
      fragment: 'membresia',
      active: true
    },
    {
      id: 5,
      title: 'Blog',
      isExternal: true,
      link: 'https://wecodeve.tumblr.com/',
      isFragment: false,
      fragment: null,
      active: true
    },
    {
      id: 6,
      title: 'Noticias',
      isExternal: false,
      link: '/',
      isFragment: true,
      fragment: 'noticias',
      active: true
    },
  ];

  whatWeDo = {
    id: 1,
    title: 'Nosotros',
    paragraph: [
      {
        id: 1,
        title: "¿Quienes Somos?",
        description: [
          "WeCode es un proyecto que busca ofrecer un espacio colaborativo de trabajo compartido con la finalidad de incentivar la creatividad de los emprendedores, estimulando el conservacionismo y la inclusión dentro de su modelo de negocio el generar bienestar a las comunidades."
        ] 
      },
      {
        id: 2,
        title: "¿Donde estamos ubicados?",
        description: [
          "Contamos con 2 sedes:",
          "Sede principal: Torre Wecode (antigua Delta) en el Rosal, Caracas-Venezuela, cuenta con una planta comercial, una mezzanina con terraza y 4 plantas para la creación de oficinas, salas y espacios innovadores que buscan ofrecer originales diseños que lleven a la inspiración e incentiven la creatividad de cada uno de nuestros contactos, conocer empresas locales, compartir ideas y crear nuevas oportunidades de negocios.",
          "Sede Alterna: Wecode Botánico en la pirámide invertida ofc 134 del Centro Comercial Tamanaco",
        ]
      },
      {
        id: 3,
        title: "¿Que ofrecemos?",
        description: [
          "PLANTA BAJA COMERCIAL: Auditorio con capacidad para hasta 60 personas, sala para hasta 30 personas sentadas con mesa, Estudio de grabación con área de trabajo disponible para post producción y otros.",
          "PLANTA MEZZANINA: Espacios con diseño original de trabajo colaborativo (coworking) con terraza disponible de acceso a todos los miembros de We Code que busquen un espacio abierto de descanso al aire libre con disponibilidad de bebidas y snacks así como dulces y otros.",
          "PLANTA TIPO (Piso 1, 2, 3): Espacio disponible para la creación de salas, escritorios fijos y espacios coworking bajo un concepto creativo, minimalista con salas de juego, recreativas y espacios de descanso y esparcimiento.",
          "BOTÁNICO: nuestra sede alterna en cct dispone de una sala de reuniones para hasta 8 personas y espacios de trabajo compartido con terraza.",
        ]
      },
      {
        id: 4,
        title: "¿Oficinas virtuales en Caracas?",
        description: [
          "Una solución para tu negocio, que te permite trabajar desde cualquier parte del territorio nacional o internacional. Proporciondole a tu compañia una plataforma física para tener una dirección comercial de la empresa y presencia en un lugar como Caracas.",
          "Beneficios:",
          "* Transmitir una imagen más profesional, cuando trabajamos como autónomos o freelance  desde casa.",
          "* Para comercios o emprendimientos online que requieren de un domicilio social, fiscal o comercial.",
          "* Recepción y almacenamiento de correo y paquetería, según contrato.",        ]
      },
    ]
  };

  ourServices = {
    title: 'Qué Ofrecemos',
    subtitle: 'Áreas de Trabajo y Esparcimiento',
    paragraph: [
      {
        title: "PLANTA BAJA COMERCIAL:",
        description: "Auditorio con capacidad para 40 personas, Estudio de grabación con área de trabajo disponible para post producción u otros.",
      },
      {
        title: "PLANTA MEZZANINA:",
        description: "Espacios con diseño original de trabajo colaborativo (coworking) con terraza disponible de acceso a todos los miembros de We Code que busquen un espacio abierto de descanso al aire libre con disponibilidad de bebidas y snacks así como dulces u otros.",
      },
      {
        title: "PLANTA TIPO (Piso 1, 2, 3):",
        description: "Espacio disponible para la creación de salas, escritorios fijos y espacios coworking bajo un concepto creativo, minimalista con salas de juego, recreativas y espacios de descanso y esparcimiento.",
      },
    ]
  };

  ourPlans = {
    title: 'Nuestro Planes',
    subtitle: 'Diseño de Espacios',
    paragraph: [
      {
        id: 1,
        title: 'DAY PASS',
        urlImg: 'assets/images/logo_we_code_t.png',
        description: 'Acceso, haciendo uso de las instalaciones y servicios, hasta la 11:59 P.M. del día de uso del Day Pass.',
        filterColor: 'bg-color-image-green',
        urlBtn: 'https://miembros.wecode.network/membership_signup/new?plan_id=e22e36e34112b93a4820a961c1d9c22f'
      },
      {
        id: 2,
        title: 'BÁSICO',
        urlImg: 'assets/images/logo_we_code_t.png',
        description: 'Acceso limitado a 40 horas de trabajo mensuales dentro de las instalaciones, haciendo uso de todos los espacios y servicios ofrecidos (lunes a viernes). Horario flexible (mañana/tarde). No incluye horas de uso de salas.',
        filterColor: 'bg-color-image-red',
        urlBtn: 'https://miembros.wecode.network/membership_signup/new?plan_id=281bcff79a85e4f581512253d00a77ed'
      },
      {
        id: 3,
        title: 'MEDIUM',
        urlImg: 'assets/images/logo_we_code_t.png',
        description: 'Acceso limitado a 80 horas de trabajo mensuales dentro de las instalaciones, haciendo uso de todos los espacios y servicios ofrecidos (lunes a viernes). Horario flexible (mañana/tarde). Incluye 2 horas de uso de salas (sujeto a disponibilidad).',
        filterColor: 'bg-color-image-grass',
        urlBtn: 'https://miembros.wecode.network/membership_signup/new?plan_id=26a2c93c56dc4665b63e724a3621b76a'
      },
      {
        id: 4,
        title: 'MENSUAL',
        urlImg: 'assets/images/logo_we_code_t.png',
        description: 'Acceso limitado a 160 horas de trabajo mensuales dentro de las instalaciones, haciendo uso de todos los espacios y servicios ofrecidos (lunes a viernes). Horario flexible (mañana/tarde). Incluye 4 horas de uso de salas (sujeto a disponibilidad).',
        filterColor: 'bg-color-image-black',
        urlBtn: 'https://miembros.wecode.network/membership_signup/new?plan_id=e22e36e34112b93a4820a961c1332aeb'
      },
      {
        id: 5,
        title: 'ILIMITADO',
        urlImg: 'assets/images/logo_we_code_t.png',
        description: 'Acceso ilimitado dentro de las instalaciones haciendo uso de todos los espacios y servicios ofrecidos (Lunes a Domingo). Incluye 6 horas de uso de salas al mes. Incluye locker grande.',
        filterColor: 'bg-color-image-orange',
        urlBtn: 'https://miembros.wecode.network/membership_signup/new?plan_id=21cc7dfcd8f7eaee20b545e2b8c3fdca'
      },
    ]
  };

  featuresMain = [
    {
      id: 1,
      title: 'La Membresia Incluye',
      list: [
        'Internet de Alta Velocidad',
        'Impresora (uso compartido).',
        'Mobiliario.',
        'Uso del espacio bajo el plan de horas adquirido.',
        'Acceso y uso de aéreas comunes, sanitarios y zona de descanso y socialización.',
        'Descuento en el alquiler de sala de reuniones, talleres u otras actividades impartidas en nuestras instalaciones.',
      ]
    },
    {
      id: 2,
      title: 'ESPACIOS:',
      list: [
        'Auditorio.',
        'Espacios de Coworking.',
        'Espacio de ocio y esparcimiento.',
        'Espacio de oficina (Escritorio fijo).',
        'Espacio cerrado (Oficina privada).',
        'Estudio de Grabación.',
      ]
    },
    {
      id: 3,
      title: 'SERVICIOS INCLUÍDOS:',
      list: [
        'WiFi.',
        'Seguridad.',
        'Recepcionistas.',
        'Servicio de limpieza.',
        'Snacks.',
        'Rincón creativo.',
        'Cafetería.',
        'Impresora (uso compartido).',
      ]
    },
  ];

  features = [
    {
      id: 1,
      icon: 'uil uil-wifi',  
      title: 'Internet de Alta Velocidad',
      description: 'Banda ancha y redundancia en el servicio con deferentes proveedores',
      filterColor: 'text-primary',
    },
    {
      id: 2,
      icon: 'uil uil-pizza-slice',  
      title: 'Snack Bar y Coffe Bar',
      description: 'Sede principal: Área comunes de Comedor, café y agua ilimitado para nuestros asociados, así como servicios de desayuno, almuerzo y snack bajo demanda del cliente.Sede Alterna: Área común de comedor, café y agua ilimitado para nuestros asociados, por estar en un área comercial como el CCCT nuestros asociados cuentan con diversas opciones de restaurantes para solicitar delivery o comer en sus instalaciones y regresar a sus actividades',
      filterColor: 'text-primary',
    },
    {
      id: 3,
      icon: 'uil uil-print',  
      title: 'Servicio de Impresion',
      description: 'Servicio que ofrecemos bajo demanda a nuestros asociados',
      filterColor: 'text-primary'
    },
    {
      id: 4,
      icon: 'uil uil-building',  
      title: 'Mobiliario',
      description: 'Escritorios fijos y espacios coworking bajo un concepto creativo, minimalista con salas de juego, recreativas y espacios de descanso y esparcimiento',
      filterColor: 'text-primary'
    },
    {
      id: 5,
      icon: 'uil uil-trees',  
      title: 'Areas de esparcimiento',
      description: 'Áreas comunes de esparcimiento y networking para todos nuestros asociados',
      filterColor: 'text-primary'
    },
    {
      id: 6,
      icon: 'uil uil-bed-double',  
      title: 'Suite',
      description: 'Si vienes desde una zona externa a caracas y también buscas donde hospedarte te damos la solución dentro de una de las suites de CCCT o la urbanización los Naranjos Caracas',
      filterColor: 'text-primary'
    },
    {
      id: 7,
      icon: 'uil uil-car-sideview',  
      title: 'Estacionamientos',
      description: 'Sede principal: Puestos comunes y gratuitos frente a la torre, así como 3 opciones de estacionamiento privado a menos de 1 cuadra. Sede Alterna: estacionamiento privado 24 horas dentro del centro comercial',
      filterColor: 'text-primary'
    },
    {
      id: 8,
      icon: 'uil uil-shield-check',  
      title: 'Seguridad',
      description: 'Circuito cerrado y seguridad 24 horas para nuestras Sedes',
      filterColor: 'text-primary'
    }
  ];

  loader = new Loader({
    apiKey: "AIzaSyCu148gaboS2539Iur199IS8meRK9TJ7sI",
    version: "weekly",
  });

  constructor() { }


  getMenu(){
    return this.menu.filter((men) => men.active === true);
  }

  getfeatures(){
    return this.features;
  }

  getPlans(){
    return this.ourPlans;
  }

  getWhat(){
    return this.whatWeDo;
  }

  getServices(){
    return this.ourServices;
  }

  // initMap is now async
  async initMap(coords: any, divId: string,mapId: string) : Promise<void> {
      let map: google.maps.Map;
      let marker;
      let infowindow;
      // Request libraries when needed, not in the script tag.
      const { Map, InfoWindow } = await this.loader.importLibrary("maps") as google.maps.MapsLibrary;
      const { Marker } = await this.loader.importLibrary("marker") as google.maps.MarkerLibrary;
      // Short namespaces can be used.
      map = new Map(document.getElementById(divId) as HTMLElement, {
          center: coords,
          zoom: 17,
          disableDefaultUI: true
      });
      map.setCenter(coords);
      marker = new Marker({position: coords, map: map}); 

      infowindow = new InfoWindow();
  }
}
